const extractErrorMessage = (error, fallBackMessage) => {
  console.log(error);
  return error.response?.data?.message || error.message || fallBackMessage;
};

export default extractErrorMessage;
